<template>
  <div class="globalSettins_page">
    <div class="settings_list">
      <GlobalSettingsItem
        v-for="(setting,key) in settings"
        :key="key"
        class="setting-item"
        :setting="setting"
        :name="key"
        @update="init"
      />
    </div>
  </div>
</template>

<script>
import GlobalSettingsItem from './Item/Index.vue'
export default {
  name: 'GlobalSettings',
  components: {
    GlobalSettingsItem
  },
  data () {
    return {
      settings: {}
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init(){
      this.$http.v1.getMonitoringSettings((response) => {
        this.settings = response.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .globalSettins_page{
    height: 100%;
    overflow-y: scroll;
  }
  .card_add{
    margin-bottom: 15px;
  }
  .settings_list{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    .setting-item{
      width: calc(33.3% - 10px);
      margin-bottom: 10px;
      margin-right: 10px;
    }
  }

  @media (max-width: 1440px) {
    .settings_list{
      .setting-item{
        width: 50%;
      }
    }
  }

  @media (max-width: 768px) {
    .settings_list{
      .setting-item{
        width: 100%;
      }
    }
  }
</style>
